import dashboard from './dashboard';
import application from './application';
import partner from './partner';
import { NavItemType } from 'types';

const menu = [];
menu.push(dashboard, partner, application);
const menuItems: { items: NavItemType[] } = {
    items: menu
};
export default menuItems;
